import { routes } from "./routes";
import { MenuItem } from "../../../../commons/ui/menu";

export const cartMenu: MenuItem = {
  key: "publicCart",
  basePath: "/cart",
  enabled: true,
  icon: "List",
  text: "Carrito",
  children: routes,
};
